/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enabled_StatusInputs */

const fr_totp_enabled_status = /** @type {(inputs: Totp_Enabled_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'authentification à deux facteurs est activée`)
};

/**

* @param {Totp_Enabled_StatusInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enabled_status = /** @type {((inputs?: Totp_Enabled_StatusInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enabled_StatusInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enabled_status(inputs)
});